export var DataSetEvents;
(function (DataSetEvents) {
    DataSetEvents["query"] = "query";
    DataSetEvents["count"] = "count";
    DataSetEvents["beforeLoad"] = "beforeLoad";
    DataSetEvents["beforeAppend"] = "beforeAppend";
    DataSetEvents["load"] = "load";
    DataSetEvents["append"] = "append";
    DataSetEvents["loadFailed"] = "loadFailed";
    DataSetEvents["submit"] = "submit";
    DataSetEvents["submitSuccess"] = "submitSuccess";
    DataSetEvents["submitFailed"] = "submitFailed";
    DataSetEvents["select"] = "select";
    DataSetEvents["unSelect"] = "unSelect";
    DataSetEvents["selectAll"] = "selectAll";
    DataSetEvents["unSelectAll"] = "unSelectAll";
    DataSetEvents["batchSelect"] = "batchSelect";
    DataSetEvents["batchUnSelect"] = "batchUnSelect";
    DataSetEvents["selectAllPage"] = "selectAllPage";
    DataSetEvents["unSelectAllPage"] = "unSelectAllPage";
    DataSetEvents["indexChange"] = "indexChange";
    DataSetEvents["update"] = "update";
    DataSetEvents["fieldChange"] = "fieldChange";
    DataSetEvents["export"] = "export";
    DataSetEvents["create"] = "create";
    DataSetEvents["beforeRemove"] = "beforeRemove";
    DataSetEvents["remove"] = "remove";
    DataSetEvents["beforeDelete"] = "beforeDelete";
    DataSetEvents["reset"] = "reset";
    DataSetEvents["validate"] = "validate";
    DataSetEvents["validateSelf"] = "validateSelf";
})(DataSetEvents || (DataSetEvents = {}));
export var ExportMode;
(function (ExportMode) {
    ExportMode["server"] = "server";
    ExportMode["client"] = "client";
})(ExportMode || (ExportMode = {}));
export var DataSetSelection;
(function (DataSetSelection) {
    DataSetSelection["single"] = "single";
    DataSetSelection["multiple"] = "multiple";
})(DataSetSelection || (DataSetSelection = {}));
export var DataSetStatus;
(function (DataSetStatus) {
    DataSetStatus["loading"] = "loading";
    DataSetStatus["submitting"] = "submitting";
    DataSetStatus["ready"] = "ready";
})(DataSetStatus || (DataSetStatus = {}));
export var DataSetExportStatus;
(function (DataSetExportStatus) {
    DataSetExportStatus["exporting"] = "exporting";
    DataSetExportStatus["success"] = "success";
    DataSetExportStatus["progressing"] = "progressing";
    DataSetExportStatus["start"] = "start";
    DataSetExportStatus["failed"] = "failed";
})(DataSetExportStatus || (DataSetExportStatus = {}));
export var RecordStatus;
(function (RecordStatus) {
    RecordStatus["delete"] = "delete";
    RecordStatus["update"] = "update";
    RecordStatus["add"] = "add";
    RecordStatus["sync"] = "sync";
})(RecordStatus || (RecordStatus = {}));
export var RecordCachedType;
(function (RecordCachedType) {
    RecordCachedType["selected"] = "selected";
    RecordCachedType["delete"] = "delete";
    RecordCachedType["update"] = "update";
    RecordCachedType["add"] = "add";
})(RecordCachedType || (RecordCachedType = {}));
export var FieldType;
(function (FieldType) {
    FieldType["auto"] = "auto";
    FieldType["boolean"] = "boolean";
    FieldType["number"] = "number";
    FieldType["currency"] = "currency";
    FieldType["string"] = "string";
    FieldType["date"] = "date";
    FieldType["dateTime"] = "dateTime";
    FieldType["week"] = "week";
    FieldType["month"] = "month";
    FieldType["year"] = "year";
    FieldType["time"] = "time";
    FieldType["object"] = "object";
    FieldType["intl"] = "intl";
    FieldType["email"] = "email";
    FieldType["url"] = "url";
    FieldType["color"] = "color";
    FieldType["json"] = "json";
    FieldType["attachment"] = "attachment";
    FieldType["secret"] = "secret";
    FieldType["reactNode"] = "reactNode";
    FieldType["bigNumber"] = "bigNumber";
})(FieldType || (FieldType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["asc"] = "asc";
    SortOrder["desc"] = "desc";
})(SortOrder || (SortOrder = {}));
export var BooleanValue;
(function (BooleanValue) {
    BooleanValue["trueValue"] = "trueValue";
    BooleanValue["falseValue"] = "falseValue";
})(BooleanValue || (BooleanValue = {}));
export var FieldIgnore;
(function (FieldIgnore) {
    FieldIgnore["always"] = "always";
    FieldIgnore["clean"] = "clean";
    FieldIgnore["never"] = "never";
})(FieldIgnore || (FieldIgnore = {}));
export var FieldTrim;
(function (FieldTrim) {
    FieldTrim["both"] = "both";
    FieldTrim["left"] = "left";
    FieldTrim["right"] = "right";
    FieldTrim["none"] = "none";
})(FieldTrim || (FieldTrim = {}));
export var FieldFormat;
(function (FieldFormat) {
    FieldFormat["uppercase"] = "uppercase";
    FieldFormat["lowercase"] = "lowercase";
    FieldFormat["capitalize"] = "capitalize";
})(FieldFormat || (FieldFormat = {}));
export var DataToJSON;
(function (DataToJSON) {
    DataToJSON["dirty"] = "dirty";
    DataToJSON["selected"] = "selected";
    DataToJSON["all"] = "all";
    DataToJSON["normal"] = "normal";
    DataToJSON["dirty-field"] = "dirty-field";
    DataToJSON["dirty-self"] = "dirty-self";
    DataToJSON["selected-self"] = "selected-self";
    DataToJSON["all-self"] = "all-self";
    DataToJSON["normal-self"] = "normal-self";
    DataToJSON["dirty-field-self"] = "dirty-field-self";
})(DataToJSON || (DataToJSON = {}));
export var CheckedStrategy;
(function (CheckedStrategy) {
    CheckedStrategy["SHOW_ALL"] = "SHOW_ALL";
    CheckedStrategy["SHOW_PARENT"] = "SHOW_PARENT";
    CheckedStrategy["SHOW_CHILD"] = "SHOW_CHILD";
})(CheckedStrategy || (CheckedStrategy = {}));
export var ValidationSelfType;
(function (ValidationSelfType) {
    ValidationSelfType["minLength"] = "minLength";
    ValidationSelfType["maxLength"] = "maxLength";
})(ValidationSelfType || (ValidationSelfType = {}));
export var DateMode;
(function (DateMode) {
    DateMode["time"] = "time";
    DateMode["dateTime"] = "dateTime";
    DateMode["week"] = "week";
    DateMode["date"] = "date";
    DateMode["month"] = "month";
    DateMode["year"] = "year";
    DateMode["decade"] = "decade";
})(DateMode || (DateMode = {}));
